import React from 'react';
import gif from '../Assets/Images/loader.gif'
const Loader = () => {
  return (
    <div id="preloader">
      <img height='320' width='350' src={gif}/>
      {/* <div data-loader="circle-side">
        </div> */}
        </div>
  );
};

export default Loader;
